import angular from 'angular'

import component from './user-details-form.component'

let module = angular.module('userDetailsFormModule', [])

.component('userDetailsForm', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-profile/components/user-details-form/index.js